import { FlexBox, Box as StyledBox } from '@onegov/react-component-library';
import { Box, Button, H2, H3, Modal } from '@snsw/react-component-library';
import { PlantItemRenewalReviewItemPage } from 'plantItemRenewal/constants/plantItemRenewalReviewItemPage';
import React, { useState } from 'react';
import { Tangible } from 'shared/constants/Tangible';

export const RenewalDetails = ({ renewalItems, onClickLookup = () => {} }) => {
  const PAGE_CONSTANTS = PlantItemRenewalReviewItemPage;
  const toRenew = renewalItems.items.filter(
    (x) => x.statusCode == Tangible.currentTangible || x.statusCode == Tangible.expiredTangible,
  ).length;
  const propertyAddress = renewalItems.property[0]?.propAddress;
  const owner = renewalItems.people[0]?.holderName;
  const businessName = renewalItems.businessName;
  const [showLookupDialog, setShowLookupDialog] = useState(false);

  return (
    <>
      <H2>{toRenew} items found at this plant location</H2>

      <Box style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <FlexBox gap={1} alignItems={'strecth'} mb={1.5}>
          <StyledBox flex="1">
            <H3>{PAGE_CONSTANTS.renewalDetailsTitle}</H3>
          </StyledBox>
          <StyledBox>
            <Button variant="link" onClick={() => setShowLookupDialog(true)}>
              Lookup again
            </Button>
          </StyledBox>
        </FlexBox>
        {renewalItems.renewalNumber && (
          <FlexBox gap={1} alignItems={'strecth'} mb={1.5}>
            <StyledBox flex="0 0 240px">
              <strong>{PAGE_CONSTANTS.renewalNumberLabel}:</strong>
            </StyledBox>
            <StyledBox>PIR-{renewalItems.renewalNumber}</StyledBox>
          </FlexBox>
        )}
        {renewalItems.itemRegistrationNumber && (
          <FlexBox gap={1} alignItems={'strecth'} mb={1.5}>
            <StyledBox flex="0 0 240px">
              <strong>{PAGE_CONSTANTS.itemRegistrationNumberLabel}:</strong>
            </StyledBox>
            <StyledBox>{renewalItems.itemRegistrationNumber}</StyledBox>
          </FlexBox>
        )}
        {renewalItems.itemLocationPostcode && (
          <FlexBox gap={1} alignItems={'strecth'} mb={1.5}>
            <StyledBox flex="0 0 240px">
              <strong>{PAGE_CONSTANTS.itemLocationPostcodeLabel}:</strong>
            </StyledBox>
            <StyledBox>{renewalItems.itemLocationPostcode}</StyledBox>
          </FlexBox>
        )}
        {propertyAddress && (
          <FlexBox gap={1} alignItems={'strecth'} mb={1.5}>
            <StyledBox flex="0 0 240px">
              <strong>{PAGE_CONSTANTS.locationAddressLabel}:</strong>
            </StyledBox>
            <StyledBox>{propertyAddress}</StyledBox>
          </FlexBox>
        )}
        {owner && (
          <FlexBox gap={1} alignItems={'strecth'}>
            <StyledBox flex="0 0 240px">
              <strong>{PAGE_CONSTANTS.ownerLabel}:</strong>
            </StyledBox>
            <StyledBox>{owner}</StyledBox>
          </FlexBox>
        )}
        {businessName && (
          <FlexBox gap={1} alignItems={'strecth'}>
            <StyledBox flex="0 0 240px"></StyledBox>
            <StyledBox>{businessName}</StyledBox>
          </FlexBox>
        )}
      </Box>
      {showLookupDialog && (
        <Modal
          title="Are you sure you want to look up another renewal?"
          buttons={[
            { text: 'Yes lookup again', onClick: onClickLookup },
            { text: 'No continue', onClick: () => setShowLookupDialog(false) },
          ]}
        >
          <p>You will lose any information you have already entered.</p>
        </Modal>
      )}
    </>
  );
};
